import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase'

function ScoreBoard({roundId, hostcupId, scores, setScores}) {



    useEffect(() => {
        try {
            const pointsRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("player_scores")
            pointsRef.orderBy("points", "desc").onSnapshot(({docs}) => {
                const scores = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setScores(scores)
            })
        } catch (error) {
            console.log(error)
        }


    }, [roundId, hostcupId])

    function deleteHandler(pointId) {
        try {
            const pointsRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("player_scores").doc(pointId)
            pointsRef.delete()
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="table-responsive">
            <h2>Scoreboard</h2>
            <table className="table table-bordered table-hover table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Spiller</th>
                        <th>Poeng</th>
                    </tr>
                </thead>
                <tbody>
                    {scores?.map((score, index) => {
                        return (
                            <tr key={index}>
                                <td>{index+1}</td>
                                <td>{score.player_name}</td>
                                <td>{score.points} <span className="float-right"> <i onClick={() => deleteHandler(score.id)} className="fas fa-trash text-danger"></i></span></td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )

}
export default ScoreBoard